import { render, staticRenderFns } from "./TariffMenu.vue?vue&type=template&id=6c814866&"
import script from "./TariffMenu.vue?vue&type=script&lang=js&"
export * from "./TariffMenu.vue?vue&type=script&lang=js&"
import style0 from "./TariffMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TariffMenu.vue"
export default component.exports